import React, { useContext } from 'react';
import './OccasionSection.css';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const OccasionSection = () => {
  const navigate = useNavigate();
  const { t } = useContext(AppContext);

  const handleOccasionClick = (occName) => {
    const slugMap = {
      Engagement: 'engagement',
      "Valentine's Day": 'valentines-day',
      Sangeet: 'wedding',
      'Wedding Day': 'wedding',
      Mehendi: 'wedding',
      Reception: 'wedding',
    };

    navigate(`/gifting/${slugMap[occName] || 'birthday'}`);
  };

  return (
    <section className="occasion-section">

      {/* ================= HEADER ================= */}
      <div className="section-header reveal">
        <h2 className="section-title">
          {t.occasionTitle}{' '}
          <span className="title-italic">
            {t.occasionTitleItalic}
          </span>
        </h2>

        <div className="title-ornament">
          <span></span>
          <span className="ornament-diamond">◆</span>
          <span></span>
        </div>
      </div>


      {/* ================= OCCASION GRID ================= */}
      <div className="occasion-grid-container">

        {/* ================= LEFT COLUMN ================= */}
        <div className="grid-column col-left">

          {/* ENGAGEMENT */}
          <div
            className="occasion-card card-image engagement ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(59, 44, 36, 0.15),
                  rgba(59, 44, 36, 0.55)
                ),
                url("images/painjan5.jpg")
              `,
            }}
            onClick={() => handleOccasionClick('Engagement')}
          >
            <div className="card-top-ribbon">🎀</div>

            <div className="card-content">
              <span>{t.occasionEngagement}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>


          {/* VALENTINE'S DAY */}
          <div
            className="occasion-card card-image mehendi ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(59, 44, 36, 0.15),
                  rgba(59, 44, 36, 0.55)
                ),
                url("images/w chain5.jpg")
              `,
            }}
            onClick={() => handleOccasionClick("Valentine's Day")}
          >
            <div className="card-top-ribbon">💖</div>

            <div className="card-content">
              <span>{t.occasionValentines}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>

        </div>


        {/* ================= CENTER COLUMN ================= */}
        <div className="grid-column col-center">

          {/* SANGEET */}
          <div
            className="occasion-card card-image sangeet ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(0, 0, 0, 0.15),
                  rgba(0, 0, 0, 0.6)
                ),
                url("images/w br9.jpg")
              `,
            }}
            onClick={() => handleOccasionClick('Sangeet')}
          >
            <div className="card-top-ribbon">🎀</div>

            <div className="card-content">
              <span>{t.occasionSangeet}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>


          {/* RECEPTION */}
          <div
            className="occasion-card card-image reception ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(59, 44, 36, 0.15),
                  rgba(59, 44, 36, 0.55)
                ),
                url("images/w ring2.jpg")
              `,
            }}
            onClick={() => handleOccasionClick('Reception')}
          >
            <div className="card-top-ribbon">🎀</div>

            <div className="card-content">
              <span>{t.occasionReception}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>

        </div>


        {/* ================= RIGHT COLUMN ================= */}
        <div className="grid-column col-right">

          {/* WEDDING DAY */}
          <div
            className="occasion-card card-image wedding ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(59, 44, 36, 0.15),
                  rgba(59, 44, 36, 0.55)
                ),
                url("images/waist17.jpg")
              `,
            }}
            onClick={() => handleOccasionClick('Wedding Day')}
          >
            <div className="card-top-ribbon">🎀</div>

            <div className="card-content">
              <span>{t.occasionWedding}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>


          {/* BRIDAL COLLECTION */}
          <div
            className="occasion-card card-image bridal-style ribbon-corner-card"
            style={{
              backgroundImage: `
                linear-gradient(
                  rgba(0, 0, 0, 0.15),
                  rgba(0, 0, 0, 0.6)
                ),
                url("images/waist22.jpg")
              `,
            }}
            onClick={() => handleOccasionClick('Wedding Day')}
          >
            <div className="card-top-ribbon">🎀</div>

            <div className="card-content">
              <span>{t.occasionBridal}</span>
              <div className="arrow-btn">➔</div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default OccasionSection;